import { ObSessionStateType } from '@central-products/interface-obsession-service';
import { publish, publishSticky } from '@wh/message-bus';
import { erase, get, set } from 'browser-cookies';
import {
  ACCOUNT_LOGIN_SUCCESS_EVENT,
  GOT_LOGIN_STATE_EVENT,
  SESSION_SYNCHRONIZATION_ERROR,
  SESSION_SYNCHRONIZED_EVENT,
} from '../../topics';
import { isDeviceNative } from './deviceDetection';
import fetchCustUserData from './fetchCustUserData';
import parseCustUserData from './parseCustUserData';

const OB_COOKIES = ['cas_ssl_login', 'cas_login', 'cust_ssl_login'];

const publishError = (message, error) => {
  publish({
    topic: SESSION_SYNCHRONIZATION_ERROR,
    data: error
      ? {
          error,
          message,
        }
      : { message },
  });
};

export const fetchCustUserDataAndNotify = (openbetLoginUrl) => () => {
  return fetchCustUserData(openbetLoginUrl)
    .then((response) => parseCustUserData(response.data))
    .then((userData) => {
      publishSticky(GOT_LOGIN_STATE_EVENT, userData);
      publishSticky(ACCOUNT_LOGIN_SUCCESS_EVENT);
    })
    .catch((error) => {
      publishError('error fetching user data', error);
    });
};

const removeCookies = (options) => {
  OB_COOKIES.forEach((cookie) => {
    erase(`hrs_remove_cookie_${cookie}`, options);
    if (get(cookie)) {
      publishError(`cookie ${cookie} was present after logout`);
      set(`hrs_remove_cookie_${cookie}`, 'true', options);
      erase(cookie, options);
    }
  });
};

export const handleOBSessionStateChange = ({ jurisdiction, domain, config }) => ({ data } = {}) => {
  if (data.state !== ObSessionStateType.SESSION_REQUESTED) {
    publish({
      topic: SESSION_SYNCHRONIZED_EVENT,
      data: { sessionSynchronized: data.state === ObSessionStateType.SESSION_EXISTS },
    });
  }

  if (jurisdiction === 'com' && isDeviceNative()) {
    return;
  }

  if (data.state === ObSessionStateType.NO_SESSION && config.removeCookie) {
    removeCookies({
      domain,
      path: '/',
    });
  }
};
